export default __webpack_public_path__ + "static/media/newsletter_cover.5d1f8884.webp";